import { msg } from '@lingui/macro';
import { formatLongNumberToString } from '../../utils/formatNumber';
export class ExchangeInfoView {
    constructor(ttl, estimatedExchangeInfo, orderExchangeInfo, nftName, currentPaymentChannel) {
        this.ttl = ttl;
        this.estimatedExchangeInfo = estimatedExchangeInfo;
        this.orderExchangeInfo = orderExchangeInfo;
        this.nftName = nftName;
        this.currentPaymentChannel = currentPaymentChannel;
    }
    get exchangeInfo() {
        return this.orderExchangeInfo || this.estimatedExchangeInfo;
    }
    get isDefaultAmount() {
        return !('rate' in this.exchangeInfo);
    }
    get amounts() {
        return this.exchangeInfo.amounts;
    }
    get fee() {
        return 'fee' in this.exchangeInfo ? this.exchangeInfo.fee : null;
    }
    get paymentChannelFees() {
        if (this.orderExchangeInfo && 'fees' in this.orderExchangeInfo) {
            return this.orderExchangeInfo.fees;
        }
        else if ('fees' in this.estimatedExchangeInfo) {
            return this.estimatedExchangeInfo.fees;
        }
        else {
            return null;
        }
    }
    get rate() {
        return 'rate' in this.exchangeInfo ? this.exchangeInfo.rate : null;
    }
    get totalFeeString() {
        var _a;
        // Use payment channel specific fee if available
        if (this.currentPaymentChannel && this.paymentChannelFees) {
            const paymentChannel = this.currentPaymentChannel === 'APPLE_PAY' || this.currentPaymentChannel === 'GOOGLE_PAY'
                ? 'CARD_PAYMENT'
                : this.currentPaymentChannel;
            const channelFee = this.paymentChannelFees[paymentChannel];
            if ((_a = channelFee === null || channelFee === void 0 ? void 0 : channelFee.total) === null || _a === void 0 ? void 0 : _a.inFiat) {
                return `${channelFee.total.inFiat.amount} ${channelFee.total.inFiat.currency}`;
            }
        }
        // Fallback to general fee
        if (!this.fee) {
            return '';
        }
        // Use backend-provided fee total
        return `${this.fee.total.inFiat.amount} ${this.fee.total.inFiat.currency}`;
    }
    get zeroFee() {
        if (!this.fee) {
            return null;
        }
        if (Number(this.fee.total.inFiat.amount) === 0) {
            return msg `Fees: ${this.totalFeeString}`;
        }
        else {
            return null;
        }
    }
    get networkFee() {
        if (!this.fee) {
            return '';
        }
        // Use backend-provided fee total
        return `${this.fee.total.inFiat.amount} ${this.fee.total.inFiat.currency}`;
    }
    get atLeastFee() {
        if (!this.fee) {
            return '';
        }
        // Use backend-provided fee total
        return `${this.fee.total.inFiat.amount} ${this.fee.total.inFiat.currency}`;
    }
    get rateString() {
        if (!this.rate) {
            return '';
        }
        if (this.nftName) {
            return `${this.nftName} = ${formatLongNumberToString(this.rate)} ${this.amounts.from.currency.code}`;
        }
        const formattedRate = formatLongNumberToString(this.rate);
        const baseString = `1 ${this.amounts.to.currency.code} = ${formattedRate} ${this.amounts.from.currency.code}`;
        return baseString;
    }
    get payAmountString() {
        return `${this.amounts.from.amount} ${this.amounts.from.currency.code}`;
    }
    get payRealAmountString() {
        return this.amounts.from.realCurrency && this.amounts.from.realAmount
            ? `${this.amounts.from.realAmount} ${this.amounts.from.realCurrency.code}`
            : null;
    }
    get receiveAmountString() {
        // Use backend-provided amount directly - no hardcoded fee adjustments
        const formattedAmount = (+this.amounts.to.amount).toFixed(3);
        return `${formattedAmount} ${this.amounts.to.currency.code}`;
    }
}
